import * as React from "react";
import { DisinvestmentStrategyType } from "../../../../../../../Wrap/Constants/Enums/Client/DisinvestmentStrategyType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { FirmInstruction } from "../../../../../../../Wrap/Models/Models/Company/FirmInstruction";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { DisinvestmentStrategyTypeMap } from "../../../../../../Dashboard/Components/Clients/PortfolioDashboard/Components/ProductOverview/Constant/Content";

interface IDisinvestmentStrategyProps extends IProcessComponentProps {
    checkBoxOption: Array<DisinvestmentStrategyType>;
    data: FirmInstruction;
}

interface IDisinvestmentStrategyState {}

export class DisinvestmentStrategySection extends ProcessComponent<
    IDisinvestmentStrategyProps,
    IDisinvestmentStrategyState
> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        super.componentDidMount();
        if (
            this.props.data?.["DisinvestmentStrategy"] == null ||
            this.props.data?.["DisinvestmentStrategy"] == DisinvestmentStrategyType.NotSpecified
        ) {
            this.populateData(DisinvestmentStrategyType.Proportional);
        }
    }

    isValid() {
        if (
            this.props.data?.["DisinvestmentStrategy"] == null ||
            this.props.data?.["DisinvestmentStrategy"] == DisinvestmentStrategyType.NotSpecified
        ) {
            return false;
        }
        return super.isValid();
    }

    private clearData = () => {
        this.populateData(DisinvestmentStrategyType.NotSpecified);
    };

    private populateData = (model: DisinvestmentStrategyType) => {
        const { onChange } = this.props;
        const add = [model];
        onChange({
            DisinvestmentStrategy: model,
        });
    };

    public render(): JSX.Element {
        return (
            <RadiosEditor
                cssWrapper="rg-inline"
                options={this.props.checkBoxOption}
                selected={this.props.data?.DisinvestmentStrategy}
                getText={(o) => DisinvestmentStrategyTypeMap[o]}
                onChange={(v) => {
                    if (v) {
                        this.populateData(v);
                    } else {
                        this.clearData();
                    }
                }}
                required="Please select"
            />
        );
    }
}
